import React, { useMemo } from 'react';

import { useFeed } from '../../Feed';
import { buildTreeOptions } from '../../../../utils';
import { useAxisData } from '../../../../contexts/AxisDataContext';
import SearchIndustries from '../../../../components/Filters/SearchIndustries/SearchIndustries';

function FeedIndustryFilterWrapper() {
  const { feedIndustries, isResultsLoading, setFeedIndustries } = useFeed();

  const { briefs } = useAxisData();

  const options = useMemo(() => {
    return buildTreeOptions(briefs);
  }, [briefs]);

  return (
    <SearchIndustries
      options={options}
      isLoading={isResultsLoading}
      applyFilters={setFeedIndustries}
      activeIndustryFilters={feedIndustries}
    />
  );
}

export default FeedIndustryFilterWrapper;
